import heartReaction from "../../images/reactions/heart-reaction.gif";
import hahaReaction from "../../images/reactions/haha-reaction.gif";
import likeReaction from "../../images/reactions/like-reaction.gif";
import thanksReaction from "../../images/reactions/thanks-reaction.png";
import sadReaction from "../../images/reactions/sad-reaction.gif";
import saluteReaction from "../../images/reactions/salute-reaction.gif";
import checkReaction from "../../images/reactions/check-reaction.gif";

import fireReaction from "../../images/reactions/fire-reaction.gif";
import snakeReaction from "../../images/reactions/snake-reaction.gif";
import chainReaction from "../../images/reactions/chain-reaction.gif";
import dollarReaction from "../../images/reactions/dollar-reaction.gif";
import armyReaction from "../../images/reactions/Army.gif";
import truckReaction from "../../images/reactions/trucking.gif";
import warehouseReaction from "../../images/reactions/warehouse.gif";
import moneybagReaction from "../../images/reactions/money-bag.gif";
import roosterReaction from "../../images/reactions/rooster.gif";
import vesselReaction from "../../images/reactions/vessel.gif";

import dragonReaction from "../../images/reactions/dragon-reaction.png";
import tigerReaction from "../../images/reactions/tiger-reaction.png";

import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

function ReactionsIndicator({ reaction, reaction_details, isThread }) {
  const [showReactionModal, setShowReactionModal] = useState(false);
  const reactionCount = reaction_details?.length || 0;

  const handleOpenReactionModal = () => setShowReactionModal(true);
  const handleCloseReactionModal = () => setShowReactionModal(false);

  useEffect(() => {
    if (!showReactionModal) return;

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setShowReactionModal(false);
      }
    };

    const previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = previousBodyOverflow;
    };
  }, [showReactionModal]);

  let reactionImg;
  switch (reaction) {
    case "haha":
      reactionImg = hahaReaction;
      break;
    case "heart":
      reactionImg = heartReaction;
      break;
    case "like":
      reactionImg = likeReaction;
      break;
    case "thanks":
      reactionImg = thanksReaction;
      break;
    case "sad":
      reactionImg = sadReaction;
      break;
    case "salute":
      reactionImg = saluteReaction;
      break;
    case "checked":
      reactionImg = checkReaction;
      break;
    case "fire":
      reactionImg = fireReaction;
      break;
    case "snake":
      reactionImg = snakeReaction;
      break;
    case "chain":
      reactionImg = chainReaction;
      break;
    case "dollar":
      reactionImg = dollarReaction;
      break;
    case "tiger":
      reactionImg = tigerReaction;
      break;
    case "dragon":
      reactionImg = dragonReaction;
      break;
    case "army":
      reactionImg = armyReaction;
      break;
    case "truck":
      reactionImg = truckReaction;
      break;
    case "warehouse":
      reactionImg = warehouseReaction;
      break;
    case "moneybag":
      reactionImg = moneybagReaction;
      break;
    case "rooster":
      reactionImg = roosterReaction;
      break;
    case "vessel":
      reactionImg = vesselReaction;
      break;
    default:
      reactionImg = likeReaction;
      break;
  }

  const reactionModal = showReactionModal ? (
    <div
      className="reaction-reactors-modal-backdrop"
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          handleCloseReactionModal();
        }
      }}
      role="presentation"
    >
      <div
        className="reaction-reactors-modal"
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="reaction-reactors-modal-header">
          <div className="reaction-reactors-modal-title-wrap">
            <img
              src={reactionImg}
              className="like-reaction reaction-reactors-modal-icon"
              alt={`${reaction} reaction`}
            />
            <div>
              <h4 className="reaction-reactors-modal-title">{reaction} reactions</h4>
              <small className="reaction-reactors-modal-subtitle">
                {reactionCount} reactor{reactionCount === 1 ? "" : "s"}
              </small>
            </div>
          </div>
          <button
            type="button"
            className="reaction-reactors-modal-close"
            onClick={handleCloseReactionModal}
            aria-label="Close reaction reactors modal"
          >
            <i className="fa fa-times" />
          </button>
        </div>
        <div className="reaction-reactors-modal-body" role="list" aria-label="Users who reacted">
          {reaction_details?.length > 0 ? (
            reaction_details.map((reactor, index) => (
              <div className="reaction-user" key={index} role="listitem">
                {reactor?.user?.display_name}
              </div>
            ))
          ) : (
            <div className="reaction-reactors-modal-empty">No reactors yet.</div>
          )}
        </div>
      </div>
    </div>
  ) : null;

  return (
    <div
      className="centered-items chat-reactions-border"
      onClick={handleOpenReactionModal}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleOpenReactionModal();
        }
      }}
      role="button"
      tabIndex={0}
      aria-haspopup="dialog"
      aria-expanded={showReactionModal}
      aria-label={`${reaction} reactions, ${reactionCount} users`}
    >
      <img src={reactionImg} className="like-reaction" alt={`${reaction} reaction`} />
      <small className="reactions-indicator">{reactionCount}</small>
      {typeof document !== "undefined" && createPortal(reactionModal, document.body)}
    </div>
  );
}

export default ReactionsIndicator;
